import SecureApi from '../../utils/secureApi';

export interface ClubDetailsData {
  _id: string;
  name: string;
  logo: string;
  emailId: string;
  managerName: string;
  countryCode: number;
  managerContactNum: number;
  location: string;
  isActive: boolean;
  // ✅ NEW FIELDS
  address?: string;
  gstNum?: string;  // API uses gstNum
}

export interface UpdateCredentialsData {
  emailId: string;
  password: string;
  confirmPassword: string;
}

export const getClubDetails = async (clubId: string): Promise<ClubDetailsData> => {
  try {
    const response = await SecureApi.get(`/api/v1/club/fetch-club-info/${clubId}`);
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || 'Failed to fetch club details');
  }
};

export const updateClubDetails = async (clubId: string, data: any): Promise<void> => {
  try {
    await SecureApi.post(`/api/v1/club/update-club-details/${clubId}`, data);
  } catch (error: any) {
    throw new Error(error.response?.data?.message || 'Failed to update club details');
  }
};

export const updateClubManagerCredentials = async (clubId: string, data: UpdateCredentialsData): Promise<void> => {
  try {
    await SecureApi.post(`/api/v1/club/update-club-manager-creds/${clubId}`, data);
  } catch (error: any) {
    throw new Error(error.response?.data?.message || 'Failed to update club manager credentials');
  }
};

export const deleteClub = async (clubId: string): Promise<void> => {
  try {
    // Use SecureApi POST method (consistent with team and player delete operations)
    await SecureApi.post(`/api/v1/club/delete-club/${clubId}`, {});
  } catch (error: any) {
    console.error('Failed to delete club:', error);
    
    // Extract meaningful error message from API response
    let errorMessage = 'Failed to delete club. Please try again.';
    
    if (error.response?.data) {
      if (typeof error.response.data === 'string') {
        errorMessage = error.response.data;
      } else if (error.response.data.message) {
        errorMessage = error.response.data.message;
      } else if (error.response.data.error) {
        errorMessage = error.response.data.error;
      } else if (error.response.data.title) {
        errorMessage = error.response.data.title;
      }
    } else if (error.message) {
      errorMessage = error.message;
    }
    
    throw new Error(errorMessage);
  }
}; 